import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  Button,
  Card,
  Input,
  Col,
  Form,
  theme,
  Grid,
  Select,
} from "antd";
import { useProviderSearchPageSrv } from "./useProviderSearchPageSrv";
import BrandColors from "@brand-colors";
import { handleErrorNavigation } from "pages/ErrorPage/ErrorHandler";
import { useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import whitelabelConfig from "@whitelabel-config";
import { usePageTitle } from "helpers/usePageTitle";

const ProviderSearchPage = () => {
  const { t } = useTranslation();
  usePageTitle("PROVIDERSEARCH_PAGE.PAGE_TITLE", `Provider Search - ${process.env.REACT_APP_PRODUCT}`);
  const { httpProviderSearch } = useProviderSearchPageSrv();
  const [providerSearch, setproviderSearch] = useState([]);
  const [rewardPoints, setRewardPoints] = useState([]);
  const [giftPoints, setGiftPoints] = useState([]);
  const [formData, setFormData] = useState({ Date: "", Reason: "" });
  const [rewardCount, setRewardCount] = useState(0);
  const [giftSummary, setGiftSummary] = useState(0);
  const [PostalCode, setPostalCode] = useState(null);
  const [Specialization, setSpecialization] = useState("");
  const [isHover, setIsHover] = useState(false);
  const { useToken } = theme;
  const { useBreakpoint } = Grid;
  const { token } = useToken();
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const uiState = useSelector((state: any) => state.portal.uiState);
  const preferredLanguage = useSelector(
    (state: any) => state.portal.uiState.Language
  );
  console.log(preferredLanguage,"preferredLanguage")
  const [isRightAlign, setIsRightAlign] = useState(false);

  const handleMouseEnter = () => {
    setIsHover(true);
  };
  const handleMouseLeave = () => {
    setIsHover(false);
  };
  const styles = {
    container: {
      margin: "0 auto",
      maxWidth: "450px",
      textAlign: "center",
      backgroundColor: token.colorBgContainer,
      zIndex: 100,
    },

    header: {
      maxWidth: "85%",
      padding: "20px 0",
      margin: " 0 auto",
      fontWeight: "600",
    },
    mainheader: {
      height: "80px",
      padding: "15px 0",
      backgroundColor: BrandColors.HEADER_BG,
    },
    subheader: {
      maxWidth: "100%",
      borderTop: "1px solid #cccccc",
    },

    text: {
      color: "#333",
      fontSize: "12px",
      lineHeight: "21px",
    },

    button: {
      backgroundColor: isHover ? token.colorBgContainer : BrandColors.BUTTON_BG,
      color: isHover ? BrandColors.BUTTON_BG : token.colorBgContainer,
      height: "42px",
      textTransform: "uppercase",
      fontWeight: "500",
      width: screens.lg ? "auto" : "100%",
      boxShadow: "none",
    },
    paragraph: {
      marginTop: 0,
      marginBottom: "10px",
      fontSize: "16px",
      textAlign: isRightAlign ? "right" : "left",
      // display: "flex",
      // flexDirection: isRightAlign ? "row-reverse" : "",
    },
    paragraph_span: {
      marginTop: 0,
      marginBottom: 0,
      fontSize: "16px",
      textAlign: isRightAlign ? "right" : "left",
      // display: isRightAlign ? "flex" : "block",
      // flexDirection: isRightAlign ? "row-reverse" : "",
    },
    card_title: {
      textAlign:  isRightAlign ? "right" : "left",
      display: "block",
      // flexDirection: isRightAlign ? "row-reverse" : "",
    }
  };
  

  useEffect(() => {    
    try {
      if (whitelabelConfig.uiSettings.rightAlignedLanguage.includes(preferredLanguage) === true) {
        setIsRightAlign(true);
      } else {
        setIsRightAlign(false);
      }
    } catch (e) {
      console.log("Error", e)
      handleErrorNavigation(e, navigate, t);
    }
  }, [ whitelabelConfig, preferredLanguage]);

  useEffect(() => {
    getProvider({});
  }, []);

  const getProvider = (payload: any) => {
    httpProviderSearch(payload).then((res) => {
      setproviderSearch(res?.data);
    });
  };
  const handleSearchReward = async (type: any) => {
    getProvider({ Specialization, PostalCode });
  };
  useEffect(() => {
    const fetchRewardList = async () => {
      try {
        const resReward = await rewardService.httpgetrewardList(
          formData.Date,
          formData.Reason
        );
        console.log("resReward", resReward.data);
        if (Array.isArray(resReward.data)) {
          setRewardPoints(resReward.data);
          setRewardCount(findSum(resReward.data, "reward"));
          console.log("rewards", findSum(resReward.data, "rewards"));
        } else {
          console.error("Reward data is not an array:", resReward.data);
        }
      } catch (error) {
        console.error("Error fetching reward list:", error);
      }
    };
    console.log("giftSummary", giftSummary);
    const fetchGiftCardDetails = async () => {
      try {
        const resGift = await rewardService.httpgetGiftCardDetails(
          formData.Date,
          formData.Reason
        );
        if (Array.isArray(resGift.data)) {
          setGiftPoints(resGift.data);
          setGiftSummary(findSum1(resGift.data, "gifts"));
          console.log("gifts", findSum(resGift.data, "gifts"));
        } else {
          console.error("gifts data is not an array:", resGift.data);
        }
      } catch (error) {
        console.error("Error fetching gift card details:", error);
      }
    };
    fetchRewardList();
    fetchGiftCardDetails();
  }, [formData]);
  const findSum = (data, type) => {
    let total = 0;
    let redeem = 0;
    for (let i = 0; i < data?.length; i++) {
      if (data[i].RewardType == 120000007) {
        total +=
          data[i].RewardValue && data[i].RewardValue > 0
            ? data[i].RewardValue
            : 0;
      }
      if (data[i].RewardType == 120000003) {
        total +=
          data[i].RewardValue && data[i].RewardValue > 0
            ? data[i].RewardValue
            : 0;
      }
    }
    return type == "reward" ? redeem : type == "giftcard" ? total : 0;
  };

  const findSum1 = (data, type) => {
    let total = 0;
    let redeem = 0;
    console.log("data", data);

    for (let i = 0; i < data?.length; i++) {
      if (data[i].RewardType == 120000007) {
        total +=
          data[i].RewardValue && data[i].RewardValue > 0
            ? data[i].RewardValue
            : 0;
      }
    }
    return total;
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const select = document.querySelector(".ant-select-selector");
      if (select) {
        const input = select.querySelector("input");
        if (input) {
          const listId = input.getAttribute("aria-controls");
          if (listId && !document.getElementById(listId)) {
            const placeholder = document.createElement("div");
            placeholder.id = listId;
            placeholder.setAttribute("role", "listbox");
            placeholder.style.display = "none";
            document.body.appendChild(placeholder);
          }
        }
        clearInterval(interval);
      }
    }, 200);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <div data-testid="provider-page">
        <Card style={{ borderRadius: "0" }}>
          <div
            style={{
              border: "1px solid black",
              padding: "10px",
              width: "100%",
              backgroundColor: "#2d3246",
              display: "flex",
              flexDirection: screens.md ? "row" : "column",
              alignItems: screens.md ? "center" : "start",
              columnGap: "10px",
              rowGap: screens.md ? "0" : "10px",
            }}
          >
            <label
              htmlFor="specialization"
              style={{ color: "white", fontSize: "16px", fontWeight: "500" }}
            >
              {t("PROVIDERSEARCH_PAGE.PROVIDER_SPECIALISATION")}
            </label>
            <Select
              id="specialization"
              defaultValue={Specialization}
              style={{
                width: screens.md ? "150px" : "100%",
                height: "42px",
                fontWeight: 700,
              }}
              onChange={(e) => setSpecialization(e)}
              options={[
                { value: "Urgent Care", label: "Urgent Care" },
                { value: "PCP", label: "PCP" },
                { value: "OB-Gyn", label: "OB-Gyn" },
                { value: "Pediatricians", label: "Pediatricians" },
              ]}
            />
            <label
              htmlFor="PostalCode"
              style={{ color: "white", fontSize: "16px", fontWeight: "500" }}
            >
              {t("PROVIDERSEARCH_PAGE.ZIP_CODE")}
            </label>
            <Input
              type="number"
              id="PostalCode"
              aria-label={t("PROVIDERSEARCH_PAGE.ZIP_CODE")}
              data-testid="PostalCode"
              value={PostalCode}
              onChange={(e) => setPostalCode(e.target.value)}
              style={{
                width: screens.md ? "auto" : "100%",
                height: "42px",
                lineHeight: "35px",
                fontWeight: 700,
              }}
            />
            <Form.Item style={{ marginBottom: "0px", width: screens.md ? "auto" : "100%" }}>
              <Button
                block={true}
                type="primary"
                data-testid="search-reward"
                onClick={(e) => handleSearchReward("reward")}
                style={styles.button}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                id="provider-search-btn"
              >
                {t("PROVIDERSEARCH_PAGE.SEARCH_BTN")}
              </Button>
            </Form.Item>
          </div>

          <div className="section-container">
            {providerSearch && providerSearch.length > 0 ? (
              <div
                style={{ display: "flex", flexWrap: "wrap", marginTop: "15px" }}
              >
                {providerSearch.map((provider, i) => (
                  <Col
                    span={12}
                    key={i}
                    style={{
                      maxWidth: screens.md ? "50%" : "100%",
                      flex: screens.md ? "0 0 50%" : "0 0 100%",
                    }}
                  >
                    <Card
                      title={                       
                        <span style={styles.card_title}>
                          <span>{t("PROVIDERSEARCH_PAGE.PROVIDER_NAME")}</span><span>:</span><span>{provider.ProviderName}</span>
                        </span>
                      }
                      bordered={false}
                      style={{ marginRight: screens.md ? "16px" : "0", marginBottom: 16 }}
                    >
                      <p style={styles.paragraph}>
                        <span>{t("PROVIDERSEARCH_PAGE.SPECIALISATION")}</span><span> : </span><span>
                        {provider.Specialization}</span>
                      </p>
                      <p style={styles.paragraph}>
                        <span>{t("PROVIDERSEARCH_PAGE.SPECIALISATION")}</span><span> :{" "} </span><span>
                        {provider.OrganizationName}</span>
                      </p>
                      <p style={styles.paragraph}>NPI: {provider.NPI}</p>
                      <p style={styles.paragraph_span}>
                        {provider.Address?.AddressLine1}
                      </p>
                      <p style={styles.paragraph_span}>
                        {provider.Address?.AddressLine2}
                      </p>
                      <p style={styles.paragraph_span}>
                        {provider.Address?.AddressLine3}
                      </p>
                      <p style={styles.paragraph_span}>
                        {provider.Address?.City}
                      </p>
                      <p style={styles.paragraph_span}>
                        {provider.Address?.State}
                      </p>
                      <p style={styles.paragraph_span}>
                        {provider.Address?.PostalCode}
                      </p>

                      <p style={styles.paragraph}>
                        {" "}
                        {t("PROVIDERSEARCH_PAGE.WORKING_HOURS")} :{" "}
                      </p>
                      <p style={styles.paragraph_span}>
                        <span style={{whiteSpace:"nowrap"}}>{" "}
                        {t("PROVIDERSEARCH_PAGE.MONDAY")}</span><span>:{" "}</span>
                        <span>{provider.WorkingHours?.Monday} </span>
                      </p>
                      <p style={styles.paragraph_span}>
                        <span style={{whiteSpace:"nowrap"}}>{" "}
                        {t("PROVIDERSEARCH_PAGE.TUESDAY")}</span><span>:{" "}</span>
                        <span>{provider.WorkingHours?.Tuesday} </span>
                      </p>
                      <p style={styles.paragraph_span}>
                        <span style={{whiteSpace:"nowrap"}}>{" "}
                        {t("PROVIDERSEARCH_PAGE.WEDNESDAY")}</span><span>:{" "}</span>
                        <span>{provider.WorkingHours?.Wednesday} </span>
                      </p>
                      <p style={styles.paragraph_span}>
                        <span style={{whiteSpace:"nowrap"}}>{" "}
                        {t("PROVIDERSEARCH_PAGE.THURSDAY")}</span><span>:{" "}</span>
                        <span>{provider.WorkingHours?.Thursday} </span>
                      </p>
                      <p style={styles.paragraph_span}>
                        <span style={{whiteSpace:"nowrap"}}>{" "}
                        {t("PROVIDERSEARCH_PAGE.FRIDAY")}</span><span>:{" "}</span>
                        <span>{provider.WorkingHours?.Friday}</span>
                      </p>
                      <p style={styles.paragraph_span}>
                        <span style={{whiteSpace:"nowrap"}}>{" "}
                        {t("PROVIDERSEARCH_PAGE.SATURDAY")}</span><span>:{" "}</span>
                        <span>{provider.WorkingHours?.Saturday}</span>
                      </p>
                    </Card>
                  </Col>
                ))}
              </div>
            ) : (
              <p>{t("PROVIDERSEARCH_PAGE.NO_RECORDS")}</p>
            )}
          </div>
        </Card>
      </div>
    </>
  );
};
export default ProviderSearchPage;